import { z } from 'zod/v4';



export const LSBookingProfileSchema = z.object({
    bookingProfileID: z.string(),
    localityID: z.string(),
    bookingProfileKey: z.string()
})

export type LSBookingProfile = z.infer<typeof LSBookingProfileSchema>;

export const LSBookingProfiles2Schema = z.object({
    BookingProfileId: z.string(),
    LocalityId: z.string()
})

export type LSBookingProfiles2 = z.infer<typeof LSBookingProfiles2Schema>;



export const LSBookingProfileRulesSchema = z.object({
    BookingProfileID: z.string(),
    BookingRuleOrder: z.number(),
    StartTime: z.string(),
    EndTime: z.string(),
    MinDuration: z.number().optional(),
    MinsBefore: z.number(),
    MinsDuring: z.number(),
    RuleDate: z.string(),
    RuleType: z.string(),
    Msg: z.string()
});

export type LSBookingProfileRules = z.infer<typeof LSBookingProfileRulesSchema>;